import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c83f61e")

_pushScopeId("data-v-2c83f61e")
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 确 定 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "替换词汇",
    modelValue: _ctx.isShowDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowDialog = $event)),
    width: 470,
    onClose: _ctx.close
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _ctx.cancel,
          size: "medium"
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.confirm,
          loading: _ctx.loading,
          size: "medium"
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        model: _ctx.formData,
        "label-position": "top",
        size: "medium"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, { label: "敏感词汇" }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.data.content,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.content = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "替换词汇" }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.data.replace,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.replace = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
})